export default __webpack_public_path__ + "static/media/Class-9-State-Hindi.dfa528de.pdf";